import styled, { css } from "styled-components";
import { Icon } from "../../../../../base/icons/icon/index.js";
import Tooltip from "../../../../../base/others/tooltip/index.js";
import { TooltipContent } from "../../../../../base/others/tooltip/styled.js";
import { FlexMixin, FontMixin } from "../../../../../../styles/common/mixins/helpers.styled.js";
import { BorderRadius } from "../../../../../../styles/common/mixins/logical.styled.js";
import Input from "../../../input/index.js";
export const TooltipMobile = styled(Tooltip).withConfig({
    displayName: "styled__TooltipMobile",
    componentId: "sc-e4ac24f4-0"
})`
	filter: unset;
	max-height: calc(100% - 104px);
	min-width: 100%;
	&[data-popper-placement^='bottom'] {
		padding-top: 0px;
	}

	${TooltipContent} {
		min-width: 100%;
		border-radius: 0px;
		overflow-y: auto;
		padding: 0px;
		text-align: left;

		&::-webkit-scrollbar {
			width: 6px;
		}
		&::-webkit-scrollbar-thumb {
			background: ${({ theme  })=>theme.colors.grays.base};
			${BorderRadius({
    all: '10px'
})}
		}
		&::-webkit-scrollbar-track {
			background: ${({ theme  })=>theme.colors.grays.light};
		}
	}
`;
export const HeaderSuggestionMobile = styled.div.withConfig({
    displayName: "styled__HeaderSuggestionMobile",
    componentId: "sc-e4ac24f4-1"
})`
	${FlexMixin({
    align: 'center'
})}
	${FontMixin({
    weight: 'regular',
    size: 'base'
})}
	background-color: ${({ theme  })=>theme.colors.headerSuggestionSearcher?.background};
	border: 1px solid ${({ theme  })=>theme.colors.grays.light};
	color: ${({ theme  })=>theme.colors.headerSuggestionSearcher?.base};
	text-transform: uppercase;
	padding: 10px 0;
`;
export const IconWrapperMobile = styled(Icon).withConfig({
    displayName: "styled__IconWrapperMobile",
    componentId: "sc-e4ac24f4-2"
})`
	${FontMixin({
    size: 'large'
})}
	color: ${({ theme  })=>theme.colors.grays.base};
	padding: 0 12px;
`;
export const LabelSuggestionMobile = styled.div.withConfig({
    displayName: "styled__LabelSuggestionMobile",
    componentId: "sc-e4ac24f4-3"
})`
	${FontMixin({
    size: 'base',
    weight: 'light',
    height: 'medium'
})}
	overflow: hidden;
	padding: 12px 20px 12px 44px;
	text-overflow: ellipsis;
	white-space: nowrap;
	color: ${({ theme  })=>theme.colors.grays.darker};
	${({ theme , $highlight  })=>$highlight && css`
			background-color: ${theme.colors.secondary.light};
			color: ${theme.colors.grays.dark};
		`};

	&:hover {
		background-color: ${({ theme  })=>theme.colors.secondary.light};
		color: ${({ theme  })=>theme.colors.grays.dark};
		cursor: pointer;
	}
`;
export const AutocompleteInputModal = styled(Input).withConfig({
    displayName: "styled__AutocompleteInputModal",
    componentId: "sc-e4ac24f4-4"
})`
	border-bottom: 1px solid ${({ theme  })=>theme.colors.grays.light};
`;

//# sourceMappingURL=styled.js.map